import axios from "axios";
import { baseApiUrl, httpRequest, getHttpHeaders } from "../ApiUtils";


const quizTypeApiUrl = `${baseApiUrl}/api/QuizType`;

export async function getQuizTypeList() {
    return await httpRequest(fetchQuizTypeList.bind(this));
}

async function fetchQuizTypeList() {
    let config = getHttpHeaders();
    return await axios.get(`${quizTypeApiUrl}`, config);
}

export async function getQuizTypeById(id) {
    return await httpRequest(fetchQuizTypeById.bind(this, id));
}

async function fetchQuizTypeById(id) {
    let config = getHttpHeaders();
    return await axios.get(`${quizTypeApiUrl}/${id}`, config);
}